const muiRadio = (theme) => {
  return {
    MuiRadio: {
      defaultProps: {
        color: 'neutral100',
      },
      styleOverrides: {
        root: {
          padding: 6,
        },
      },
    },
  };
};

export default muiRadio;
